import * as AuthApis from './AuthApii';
import * as OrganizationApis from './organization';
import * as TenderApis from './tender';
import * as UsersApis from './users';
import * as CompanyApis from './companies';
import * as BidsApis from './bids';
import * as MessageApis from './message';
import * as NotificationApis from './notification';
import * as ChatsApis from './chats';

export const ApiManager = {
  ...AuthApis,
  ...OrganizationApis,
  ...TenderApis,
  ...UsersApis,
  ...CompanyApis,
  ...BidsApis,
  ...MessageApis,
  ...NotificationApis,
  ...ChatsApis,
};
